import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) => createStyles({
    popover: {
        pointerEvents: 'none',
    },
    paper: {
        padding: theme.spacing(1),
        maxWidth: '400px',
    },
});